import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { AsyncPaginate } from 'react-select-async-paginate';
import axios from "axios";

const ContactPopupWidget = ({ config, onHide, show }) => {
  const [options, setOptions] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [postLoading, setPostLoading] = useState(false);
  const [postSucess, setPostSucess] = useState(false);
  const [postError, setPostError] = useState(false);
  const [conversationId, setConversationId] = useState(null);

  async function loadRecipientOptions(search, loadedOptions) {
    try {
      const response = await axios.get(`/api/v1/contact-center/recipients/?search=${search}&offset=${loadedOptions.length}&limit=5`, {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": window.location.pathname.split("/")[1]
        },
        withCredentials: true,
        xsrfCookieName: "csrftoken",
        xsrfHeaderName: "X-CSRFToken",
      });

      return {
        options: response.data.results.map((i) => ({
          value: i.pk,
          label: i.full_name,
        })),
        hasMore: !(response.data.next === null),
      };
    } catch (error) {
      console.error("Error al requerir los recipients:", error);
    };
  };

  async function postMessage(conversation_id, payload) {
    try {
      const response = await axios.post(
        `/api/v1/contact-center/conversations/${conversation_id}/messages/`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": window.location.pathname.split("/")[1]
          },
          withCredentials: true,
          xsrfCookieName: "csrftoken",
          xsrfHeaderName: "X-CSRFToken",
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  const handleOptionChange = (option) => {
    setSelectedOption(option.value);
  };

  //POST /api/v1/contact-center/conversations/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setPostLoading(true);
    const payload = {
      recipient: selectedOption,
      subject: event.target.subject.value,
    };

    try {
      const response = await axios.post( //crear conversacion 
        "/api/v1/contact-center/conversations/",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
          xsrfCookieName: "csrftoken",
          xsrfHeaderName: "X-CSRFToken",
        }
      );

      const conversationId = response?.data.pk;
      const payloadMsg = {
        body: event.target.message.value,
      };

      postMessage(conversationId, payloadMsg)// postear mensaje
        .then((data) => {
          event.target.reset();
          setSelectedOption("");
          setPostLoading(false);
          setPostSucess(true);
          setPostError(false);
          setConversationId(conversationId); 
        })
        .catch((error) => {
          console.log(error);
          setPostLoading(false);
          setPostSucess(false);
          setPostError(true);
          setConversationId(null);
        });
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      setPostLoading(false);
      setPostSucess(false);
      setPostError(true);
      setConversationId(null);
    }
  };
  return (
    <Modal show={show} onHide={onHide} className="SuggestionForm">
      <Modal.Header>
        <Modal.Title>{config.translations.contactTitle}</Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => {
            onHide();
          }}
        ></button>
      </Modal.Header>
      <>
        {!postSucess ? (
          <Modal.Body>
            <form onSubmit={handleSubmit}>
              <AsyncPaginate
                id="recipients"
                placeholder={config.translations.contactFormLabelSelect}
                aria-label={config.translations.contactFormLabelFor}
                cacheOptions
                defaultOptions
                loadOptions={loadRecipientOptions}
                onChange={handleOptionChange}
                required
                isSearchable
                loadingMessage={() => config.translations.contactFormSearching}
                noOptionsMessage={
                  ({ inputValue }) => inputValue
                    ? config.translations.contactFormNoUsersFound
                    : config.translations.contactFormStartSearching
                }
                />
              <div className="mt-4">
                <label className="form-label fw-bold" htmlFor="subject">
                  {config.translations.contactFormLabelSubject}
                </label>
                <input
                  className="form-control"
                  name="subject"
                  defaultValue=""
                  id="subject"
                  required
                  maxLength="255"
                  type="text"
                  placeholder={config.translations.contactFormSubjectPH}
                ></input>
              </div>
              <div className="mt-4">
                <label className="form-label fw-bold" htmlFor="message">
                  {config.translations.contactFormLabelMessage}
                </label>
                <textarea
                  style={{ minHeight: "150px" }}
                  className="form-control"
                  name="message"
                  defaultValue=""
                  id="message"
                  required
                  maxLength="255"
                  placeholder={config.translations.contactFormMessagePH}
                ></textarea>
              </div>
              {postError && (
                <p className="SuggestionForm-error">
                  {config.translations.contactFormError}
                </p>
              )}
              <div className="horizontal-center mt-4">
                <button
                  className="btn btn-primary horizontal-center gap-2"
                  type="submit"
                  disabled={postLoading}
                >
                  {postLoading ? (
                    <>
                      <span
                        className="spinner-border text-light spinner-border-sm"
                        aria-hidden="true"
                      ></span>
                      <span role="status">Cargando...</span>
                    </>
                  ) : (
                    <>{config.translations.contactFormSubmitBtn}</>
                  )}
                </button>
              </div>
            </form>
          </Modal.Body>
        ) : (
          <Modal.Body>
            <div className="horizontal-center flex-column gap-4">
              <i
                className="fa-solid fa-circle-check text-success"
                style={{ fontSize: "4rem" }}
              ></i>
              <h4 className="fs-4 text-center">
                {config.translations.contactFormSucessMsg}
              </h4>
              <a
                className="btn btn-primary"
                href={`${window.location.origin}/${config.lang}/${conversationId ? `contact-chat/${conversationId}/` : "contact-center/"}`}
              >
                {config.translations.contactFormShowChatsBtn}
              </a>
            </div>
          </Modal.Body>
        )}
      </>
    </Modal>
  );
};

export default ContactPopupWidget;
